import React from 'react';
import PropTypes from 'prop-types';
import PanelType from '../models/panel-type';
import TabBar from './tab-bar';
import * as styles from './panels.style';
import { jsx as ___EmotionJSX } from "@emotion/core";
var Panels = _ref => {
  var type = _ref.type,
    panels = _ref.panels,
    activePanelIndex = _ref.activePanelIndex,
    setActivePanel = _ref.setActivePanel,
    customTabs = _ref.customTabs,
    tabJustification = _ref.tabJustification,
    tabAlignment = _ref.tabAlignment,
    tabGap = _ref.tabGap,
    underline = _ref.underline,
    className = _ref.className,
    tabWrapper = _ref.tabWrapper,
    tabColour = _ref.tabColour,
    tabBorderColour = _ref.tabBorderColour,
    tabInactiveColour = _ref.tabInactiveColour,
    tabCountColour = _ref.tabCountColour,
    hoverColour = _ref.hoverColour;
  var isCss = type === 'css';
  var renderActivePanel = () => panels.map((panel, index) => {
    var _panels$activePanelIn, _panels$activePanelIn2;
    if (!panel) {
      return null;
    }
    var isActive = index === activePanelIndex;
    return (isCss || isActive) && ___EmotionJSX("div", {
      "data-test-id": "panel ".concat(isActive ? '' : 'in', "active"),
      css: isActive || styles.inactiveContents,
      key: panel.tab.id
    }, typeof panel.content === 'function' ? panel.content({
      isActive,
      index,
      tabId: panel.tab.id,
      activePanelIndex,
      activePanel: (_panels$activePanelIn = panels[activePanelIndex]) === null || _panels$activePanelIn === void 0 ? void 0 : (_panels$activePanelIn2 = _panels$activePanelIn.tab) === null || _panels$activePanelIn2 === void 0 ? void 0 : _panels$activePanelIn2.id
    }) : panel.content);
  });
  var tabs = panels.map(panel => panel === null || panel === void 0 ? void 0 : panel.tab);
  return ___EmotionJSX("div", {
    className: className
  }, ___EmotionJSX(TabBar, {
    tabs: tabs,
    activeIndex: activePanelIndex,
    tabAlignment: tabAlignment,
    tabJustification: tabJustification,
    tabGap: tabGap,
    underline: underline,
    onClick: setActivePanel,
    tabWrapper: tabWrapper,
    customTabs: customTabs,
    tabColour: tabColour,
    tabBorderColour: tabBorderColour,
    tabInactiveColour: tabInactiveColour,
    tabCountColour: tabCountColour,
    hoverColour: hoverColour
  }), ___EmotionJSX("div", {
    css: styles.activePanel
  }, renderActivePanel()));
};
Panels.propTypes = {
  panels: PropTypes.arrayOf(PropTypes.shape(PanelType)).isRequired,
  activePanelIndex: PropTypes.number,
  setActivePanel: PropTypes.func.isRequired,
  tabJustification: PropTypes.oneOf(['left', 'right', 'full', 'auto']).isRequired,
  tabAlignment: PropTypes.oneOf(['left', 'centre']).isRequired,
  tabGap: PropTypes.oneOf(['default', 'big']).isRequired,
  underline: PropTypes.bool.isRequired,
  tabWrapper: PropTypes.element,
  tabColour: PropTypes.string,
  tabBorderColour: PropTypes.string,
  tabInactiveColour: PropTypes.string,
  tabCountColour: PropTypes.string,
  className: PropTypes.string,
  type: PropTypes.oneOf(['js', 'css']),
  hoverColour: PropTypes.string,
  customTabs: PropTypes.arrayOf(PropTypes.node)
};
Panels.defaultProps = {
  tabWrapper: undefined,
  tabColour: undefined,
  tabBorderColour: undefined,
  tabCountColour: undefined,
  tabInactiveColour: undefined,
  activePanelIndex: 0,
  className: null,
  type: 'js',
  hoverColour: undefined,
  customTabs: []
};
export default Panels;